import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import IPropTypes from 'react-immutable-proptypes'
import log from 'loglevel'

import hocConnect from './hocConnect'

import './style.scss'

const loaderDiv = document.getElementById('loader')
if (!loaderDiv) log.warn('You must define loader element with id #loader !')

@hocConnect
export default class Loader extends Component {
    static propTypes = {
        loaders: IPropTypes.map.isRequired,
    }

    renderLoader = (id, text) => {
        const textEl = text && <div className={'text'}>{text}</div>

        return (
            <div key={id} className={'main-loader'}>
                <div className={'body'}>
                    <div className={'image'} />
                    {textEl}
                </div>
            </div>
        )
    }

    render() {
        const { loaders } = this.props

        if (loaders.isEmpty()) return null

        const loadersEl = loaders.map((loader, id) => this.renderLoader(id, loader.get('text', null))).toArray()

        return ReactDOM.createPortal(loadersEl, loaderDiv)
    }
}
